<template>
    <div class="">
        <div class="flex flex-wrap bg-white px-6" style="place-content: start;gap: 20px;">
            <div class="flex items-center" v-for="(legendItem, index) in orgRelationships" :key="index">
                <div class="p-1 flex items-center" :style="{ 'background-color': colorsFromKey[legendItem.key],'border-radius': '2em' }">
                <label class="cursor-pointer m-1" :for="'legend-' + index" :style="{ color: '#fff' }">
                    {{ legendItem.label }}</label>
                <input class="m-1 cursor-pointer" type="radio" :id="'legend-' + index" :value="legendItem.key"
                    v-model="selectedLegends" name="selectedLegends" :checked="(selectedLegends==legendItem.key)?true:false"/>
                </div>
            </div>
        </div>
        <div id="organisation-chart-body" class="organisationChartBody" ref="organiGramBox"></div>
    </div>
</template>

<script>

import constants from "@/constants";
import { OrganiGram } from './src/organi-gram';
import { array } from '@amcharts/amcharts4/core';
const chartObject = new OrganiGram('abc123def456','TEAM');
export default {
    props : {
        'importData' : array
    },
    name: 'OrganiGram',
    data() {
        return {
            uData: '',
            chartData : null,
            dataCollection : '',
            selectedLegends : 1,
            colorsFromKey: {
                0: "#FF6347",
                1: "#0BA5EC",
                2: "#7A5AF8",
                3: "#12B76A",
                4: "#FB6514",
                5: "#4E5BA6",
                6: "#F2C046",
                7: "#EE46BC",
                8: "#F36677",
                9: "#808000",
                10: "#FF69B4",
                11: "#C6211B",
                12: "#A52A2A",
                13: "#008080",
                14: "#708090",
            },
        }
    },
    computed: {
        avatarNameGenerator() {
            return this.$store.state.users.avatarNameGenerator;
        },
        orgRelationships() {
            return this.$store.state.organization.organizationConfiguration.relationship.values.filter(
                (e) => e.key > 0
            );
        },
        orgData() {
            return this.$store.state.organization.orgData;
        },
        userData() {
            return this.$store.state.users.data;
        },
        employeesData() {
            return this.$store.state.organization.employees;
        },
    },
    watch: {
        selectedLegends(newVal) {
            this.createData(newVal);
            this.renderChart(this.dataCollection);
            return newVal;
        },
    },
    methods: {
        renderChart(data) {
            
            this.chartData = data;
            chartObject.container('organisation-chart-body')
                        .root({
                            id:'',
                            name:'',
                            image: ''})
                        .type('image')
                        .data(this.chartData)
                        .collapsed(false)
                        .searchContainer('hierarchy-search-box')
                        .displaySettings({
                            cardColor : this.colorsFromKey[this.selectedLegends],
                            textColor : '#FFF',
                            borderColor: 'rgba(250,250,0,0.1)'
                        }).render();
        },
        async createData(val) {
            this.dataCollection = this.employeesData.map(m =>  
            ({
                id : m.userId,
                name : m.userData.firstName+' '+m.userData.lastName,
                positionName : '',
                imageUrl : (m.userData.profilePictureUrl)?`${constants.s3Bucket}/editor/profile-pictures/${m.userData.profilePictureUrl}`:`https://hostedboringavatars.vercel.app/api/beam?name=${m.userData.firstName}`,
                parentId : (!m.employeeRelationshipsData || m.employeeRelationshipsData.length == 0) ? '' :  (m.employeeRelationshipsData.filter((e) => e.relationship.key === val).map((m) => m.userIdTo)[0] || ''),
                emailId : m.userData.email,
                relation: this.orgRelationships[this.selectedLegends - 1].label 
            })) 
            return true;
        },
        updateChart() {
            const _mainContainer = document.getElementById("organisation-chart-body");
            var draggedFrom  = '';
            _mainContainer.addEventListener('dragstart',(event)=>{
                event.stopPropagation();
                if(event.target.classList.contains('emptitle')){
                    draggedFrom = event.target.parentNode;
                }
            })
            document.addEventListener('dragover',(event)=>{
                event.preventDefault();
            //    event.stopPropagation();
            })
            _mainContainer.addEventListener('drop',(event)=>{
                event.dataTransfer.dropEffect = "move";
                if(event.target.classList.contains('emptitle')){
                   let _nextParent = event.target.parentNode.id;
                   let _prevParent = draggedFrom.dataset.parentid;
                   event.target.parentNode.append(draggedFrom);
                   const relation = {
                       'key':this.orgRelationships[this.selectedLegends - 1].key,
                       'label':this.orgRelationships[this.selectedLegends - 1].label
                   }
                    if(_prevParent && (_prevParent != null || _prevParent != '')){
                        this.removeRelationship(draggedFrom.dataset,relation).then(res=>{
                            if(res.status==="SUCCESS" && _nextParent && (_nextParent!=null || _nextParent != '' || _nextParent != 0)) this.saveRelation(draggedFrom.dataset,relation);
                        })
                    }
                    else{
                        draggedFrom.dataset.parentid = _nextParent;
                        this.saveRelation(draggedFrom.dataset,relation);
                    }
                }
                
            })
        },
        saveRelation(updatedData,relation) {
            const payload = {
                userIdFrom: updatedData.id,
                userIdTo: updatedData.parentid,
                assignedByUserId: this.userData._id,
                relationship: relation,
                organizationId: this.orgData._id,
            };
            console.log("your save payload",payload);
            this.$store
            .dispatch("organization/saveEmployeeRelation", payload)
            .then((res) => {
            if (res.message === "Relationship Saved Successfully") {
                this.$vs.notify({
                color: "success",
                text: "Relationship added successfully",
                });
                this.$forceUpdate();
                return true;
            }
            })
            .catch((err) => {
                console.log(err);
                return false;
            })
        },
        async removeRelationship(updatedData,relation) {
            const payload = {
                userIdFrom: updatedData.id,
                userIdTo: updatedData.parentid,
                relationship: relation,
                organizationId: this.orgData._id,
            };
            return this.$store.dispatch("organization/removeEmployeeRelationship", payload)
            .then((res) => {
                if (res.status === "SUCCESS") {
                        this.$vs.notify({
                        color: "success",
                        text: "Relationship removed successfully",
                    });
                    this.$forceUpdate();
                }
                return res;
            })
            .catch(err => {throw err} )
            .finally((res)=> { return res});
        },
    },
    mounted (){
      // this.renderChart(this.dataCollection);
       this.updateChart();
    },
    created() {
        this.createData(this.selectedLegends).then((res)=>{
            if(res) this.renderChart(this.dataCollection);
        });
    }
}
</script>

<style>
@import '../OrganiGram/public/css/app.css';
</style>